<template>
  <div id="app">
    <AppHeader />
    <AppMain />
    <AppFooter />
    <WhatsappWidget />
    <PromoPopup />
  </div>
</template>

<script>
import AppHeader from './components/Header.vue';
import AppMain from './components/Main.vue';
import AppFooter from './components/Footer.vue';
import WhatsappWidget from './components/WhatsappWidget.vue';
import PromoPopup from './components/PromoPopup.vue';

export default {
  name: 'App',
  components: { AppHeader, AppMain, AppFooter, WhatsappWidget, PromoPopup },
};
</script>

<style>
/* ---------- Colores y tipografías de la marca ---------- */
:root {
  --green: #004225;      /* verde inglés */
  --green-dark: #02301d;
  --green-mid: #0a5a38;
  --mint: #9be3b5;
  --tint: #eaf4ee;
  --text: #06281a;
  --muted: #3f5a4a;
  --whatsapp: #25d366;
  --display: 'Unbounded', 'Arial Black', Arial, sans-serif;
  --body: 'Manrope', system-ui, -apple-system, 'Segoe UI', Roboto, Arial, sans-serif;
  --mono: 'JetBrains Mono', ui-monospace, Menlo, Consolas, monospace;
}

/* ---------- Base ---------- */
*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(37, 211, 102, 0.25);
}

body {
  margin: 0;
  background: #ffffff;
  color: var(--text);
  font-family: var(--body);
  font-size: 1rem;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

img {
  max-width: 100%;
}

a {
  color: var(--green);
}

:focus-visible {
  outline: 3px solid #1f9d5f;
  outline-offset: 3px;
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* ---------- Piezas compartidas ---------- */
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding-left: max(24px, env(safe-area-inset-left));
  padding-right: max(24px, env(safe-area-inset-right));
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 48px;
  padding: 16px 28px;
  border-radius: 999px;
  border: 2px solid transparent;
  font-family: var(--body);
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  transition: transform 0.15s ease, background-color 0.15s ease;
}

.btn:hover {
  transform: translateY(-2px);
}

.btn--green {
  background: var(--green);
  color: #ffffff;
}

.btn--green:hover {
  background: var(--green-mid);
  color: #ffffff;
}

.btn--white {
  background: #ffffff;
  color: var(--green);
}

.btn--white:hover {
  background: #e6f5eb;
  color: var(--green);
}

.btn--outline {
  background: #ffffff;
  border-color: var(--green);
  color: var(--green);
}

.btn--outline:hover {
  background: var(--tint);
  color: var(--green);
}

.eyebrow {
  margin: 0;
  font-family: var(--mono);
  font-size: 0.8rem;
  font-weight: 500;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}
</style>
